import {
    EpgProgram,
    MixedItem,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

export default function getChannelId(
    item:
        | EpgProgram
        | RBProgram
        | VodEditorial
        | MixedItem
        | RecordingMetadata
        | undefined,
) {
    if (!item) {
        return undefined;
    }

    if ('channelId' in item && item.channelId) {
        return item.channelId;
    }

    if ('serviceRef' in item && item.serviceRef) {
        return item.serviceRef;
    }

    const editorialItem = item as VodEditorial;
    const mixedItem = item as MixedItem;

    return (
        editorialItem.technicals?.[0]?.ServiceId ||
        mixedItem.links?.[0]?.ServiceId ||
        undefined
    );
}
